import { useEffect, useState } from "react";
import { Form, useActionData, useNavigation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import "./Security.css";
import hideIcon from "../../../assets/hide-icon.svg";
import showIcon from "../../../assets/show-icon.svg";
import securityImg from "../../../assets/security-img.png";

import { API_BASE_URL } from "../../../config";
import { getAuthToken } from "../../../auth/auth";

export default function Security() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(
    "The new password field must be at least 8 characters."
  );
  const [repeatPassword, setRepeatPassword] = useState("");
  const [showPassowrd, setShowPasswod] = useState({
    old: false,
    new: false,
    repeat: false,
  });
  const [error, setError] = useState(false);
  const errorData = useActionData();
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  useEffect(() => {
    if (errorData?.success) {
      toast.success("Password updated successfuly!");
      setOldPassword("");
      setNewPassword("");
      setRepeatPassword("");
    }

    if (errorData?.error) {
      toast.error("Password updated failed.");
      setError(false);
      setOldPassword("");
      setNewPassword("");
      setRepeatPassword("");
    }
  }, [errorData]);

  useEffect(() => {
    if (newPassword.length > 0 && newPassword.length < 8) {
      setError(true);
      setErrorMessage("The new password field must be at least 8 characters.");
    } else if (repeatPassword.length > 0 && newPassword !== repeatPassword) {
      setError(true);
      setErrorMessage("Password do not match.");
    } else {
      setError(false);
    }
  }, [repeatPassword, newPassword]);

  const toggleVisibility = (field) => {
    setShowPasswod((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  return (
    <>
      <section id="security">
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="container">
          <div className="row-essy">
            <div className="col-essy-lg-6 col-essy-md-6">
              <div className="security-form">
                <h1>Security</h1>
                <Form method="post">
                  <div className="form-group">
                    <label>Old Password</label>
                    <div className="password-input-wrapper">
                      <input
                        onChange={(e) => setOldPassword(e.target.value)}
                        type={showPassowrd.old ? "text" : "password"}
                        value={oldPassword}
                        name="old_password"
                      />
                      <span
                        className="show-password"
                        onClick={(e) => toggleVisibility("old")}
                      >
                        <img
                          src={showPassowrd.old ? showIcon : hideIcon}
                          alt="password icon"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>New Password</label>
                    <div className="password-input-wrapper">
                      <input
                        onChange={(e) => setNewPassword(e.target.value)}
                        type={showPassowrd.new ? "text" : "password"}
                        value={newPassword}
                        name="new_password"
                      />
                      <span
                        className="show-password"
                        onClick={(e) => toggleVisibility("new")}
                      >
                        <img
                          src={showPassowrd.new ? showIcon : hideIcon}
                          alt="password icon"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Repeat Password</label>
                    <div className="password-input-wrapper">
                      <input
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        type={showPassowrd.repeat ? "text" : "password"}
                        value={repeatPassword}
                        name="repeat_password"
                      />
                      <span
                        className="show-password"
                        onClick={(e) => toggleVisibility("repeat")}
                      >
                        <img
                          src={showPassowrd.repeat ? showIcon : hideIcon}
                          alt="password icon"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="error-message">
                    {error && <p className="error-text">{errorMessage}</p>}
                    {errorData?.error &&
                      (typeof errorData.error === "string" ? (
                        <p className="error-text">{errorData.error}</p>
                      ) : (
                        <ul>
                          {Object.entries(errorData.error).map(
                            ([field, messages]) =>
                              Array.isArray(messages) ? (
                                messages.map((msg, index) => (
                                  <li key={`${field}-${index}`}>{msg}</li>
                                ))
                              ) : (
                                <li key={field}>{messages}</li>
                              )
                          )}
                        </ul>
                      ))}
                  </div>

                  <button type="submit" className="btn-all-white">
                    {isSubmitting ? "Saving Changes..." : "Save Changes"}
                  </button>
                </Form>
                <div className="security-contact-us">
                  <h4>
                    Have Questions? <br />
                    Contact Us
                  </h4>
                  <a href="mailto:support@essy.com">support@essy.com</a>
                </div>
              </div>
            </div>
            <div className="col-essy-lg-6 col-essy-md-6">
              <div className="security-img">
                <img src={securityImg} alt="security" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export const securityActionData = async ({ request }) => {
  const formData = await request.formData();
  const token = getAuthToken();
  console.log(token);

  const data = {
    old_password: formData.get("old_password"),
    new_password: formData.get("new_password"),
    new_password_confirmation: formData.get("repeat_password"),
  };

  const response = await fetch(`${API_BASE_URL}/user/change-password`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (result.success === false) {
    return {
      error:
        result.errors || result.message || "Update failed. Please try again",
    };
  }

  return { success: true };
};
